var map = {
	"./brand1.svg": 34,
	"./brand10.svg": 35,
	"./brand11.svg": 36,
	"./brand12.svg": 37,
	"./brand13.svg": 38,
	"./brand14.svg": 39,
	"./brand15.svg": 40,
	"./brand16.svg": 41,
	"./brand17.svg": 42,
	"./brand2.svg": 43,
	"./brand3.svg": 44,
	"./brand4.svg": 45,
	"./brand5.svg": 46,
	"./brand6.svg": 47,
	"./brand7.svg": 48,
	"./brand8.svg": 49,
	"./brand9.svg": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;